





































































































import MagesDesc from './descriptions/Mages'
import FatHooksDesc from './descriptions/FatHooks'
import ShootoutDesc from './descriptions/Shootout'
ServersCollection = null

promise = null
importFirebase = ->
  promise ?= `import('firebase-integration')`


export default
  components: {
    MagesDesc, FatHooksDesc, ShootoutDesc,
    Firebase: -> (await importFirebase()).Firebase
    DetectRTC: -> `import('./DetectRTC')`
    ServerList: -> (await importFirebase()).ServerList
  }

  props: ['game']

  data: ->
    iframe = frameElement? or window.location isnt window.parent.location
    iframe = false# if @$route.query.s is 'cg'
    serversCollection: null
    servers: null
    region: null
    supported: null
    newServerList: @game?.game in ['mages', 'shootout']
    inIframe: iframe

  watch:
    game: ->
      @region = null
      @newServerList = @game?.game in ['mages', 'shootout']
      if @servers?
        @serversCollection.ref.off()
        @loadServers()

  beforeDestroyed: ->
    @serversCollection.ref.off()

  computed:
    regions: ->
      return if not @servers?
      regions = []
      for region, servers of @servers
        hasServer = false
        playersCount = 0
        for _, { count } of servers
          hasServer = true
          playersCount += count
        if hasServer
          regions.push { region, playersCount, ping: @serversCollection.regions[region].ping }
      regions

    actualServers: ->
      @servers[@region.region] if @region

    pings: ->
      @serversCollection.regions

    isMages: ->
      @game.game is 'mages'

    isMagesSoccer: ->
      @game.name is 'Mages Soccer'

  methods:
    loadServers: (opt) ->
      filter = -> true
      if @isMages
        if @isMagesSoccer
          filter = _.mode.is 'Soccer'
        else
          filter = _.mode.isnt 'Soccer'
      ServersCollection = opt.ServersCollection if opt?
      @$set this, 'serversCollection', new ServersCollection(@game.game, @$set.bind(this), filter)
      @$set this, 'servers', @serversCollection.servers

    openInWindow: (url) ->
      open(url)

